// src/client/ImportImage.jsx

import logoAcb from "../assets/images/banks/acb.jpg";
import logoBidv from "../assets/images/banks/bidv.jpg";
import logoMbb from "../assets/images/banks/mbb.jpg";
import logoSeab from "../assets/images/banks/seab.jpg";
import logoTcb from "../assets/images/banks/tcb.jpg";
import logoVcb from "../assets/images/banks/vcb.jpg";
import logoVtb from "../assets/images/banks/vtb.jpg";

// Import images
import bgAcb from "../assets/images/banks/bg-acb.jpg";
import logoAcbWhite from "../assets/images/banks/acb-white.png";
import bgBidv from "../assets/images/banks/bg-bidv.jpg";
import logoBidvWhite from "../assets/images/banks/bidv-white.png";
import bgMbb from "../assets/images/banks/bg-mbb.jpg";
import logoMbbWhite from "../assets/images/banks/mbb-white.png";
import bgMomo from "../assets/images/banks/bg-momo.jpg";
import logoMomoWhite from "../assets/images/banks/momo-white.png";
import bgSeab from "../assets/images/banks/bg-seab.jpg";
import logoSeabWhite from "../assets/images/banks/seab-white.png";
import bgTcb from "../assets/images/banks/bg-tcb.jpg";
import logoTcbWhite from "../assets/images/banks/tcb-white-old.png";
import bgTpb from "../assets/images/banks/bg-tpb.jpg";
import logoTpbWhite from "../assets/images/banks/tpb-white.png";
import bgVcb from "../assets/images/banks/bg-vcb.jpg";
import logoVcbWhite from "../assets/images/banks/vcb-white.png";
import bgVtb from "../assets/images/banks/bg-vtb.jpg";
import logoVtbWhite from "../assets/images/banks/vtb-white.png";

export const bankLogos = {
  logoAcb,
  logoBidv,
  logoMbb,
  logoSeab,
  logoTcb,
  logoVcb,
  logoVtb,
  logoAcbWhite,
  logoBidvWhite,
  logoMbbWhite,
  logoMomoWhite,
  logoSeabWhite,
  logoTcbWhite,
  logoTpbWhite,
  logoVcbWhite,
  logoVtbWhite,
  bgAcb,
  bgBidv,
  bgMbb,
  bgMomo,
  bgSeab,
  bgTcb,
  bgTpb,
  bgVcb,
  bgVtb,
};
